import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { VerificationTemplateVersionDiff } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateVisualVersionDiff/types';
import { MatchRequirementProfile } from 'dashboard/models/match-requirement-profile';
import { VerificationTemplate } from 'dashboard/models/verification-template';
import {
  VerificationTemplateVersion,
  VerificationTemplateVersionSchema,
} from 'dashboard/models/verification-template-version';

export interface VerificationTemplateState {
  verificationTemplate: VerificationTemplate | undefined;
  verificationTemplateVersion: VerificationTemplateVersion | undefined;
  latestPublishedVerificationTemplateVersion: VerificationTemplateVersion | undefined;
  matchRequirementProfiles: MatchRequirementProfile[] | undefined;
  schema: VerificationTemplateVersionSchema | undefined;
  verificationTemplateVersionDiff: VerificationTemplateVersionDiff | undefined;
}

export const initialState: VerificationTemplateState = {
  verificationTemplate: undefined,
  verificationTemplateVersion: undefined,
  latestPublishedVerificationTemplateVersion: undefined,
  matchRequirementProfiles: undefined,
  schema: undefined,
  verificationTemplateVersionDiff: undefined,
};

// verification template
interface SetVerificationTemplatePayload {
  verificationTemplate: VerificationTemplate | undefined;
}

interface SetVerificationTemplateVersionPayload {
  verificationTemplateVersion: VerificationTemplateVersion | undefined;
}

interface SetMatchRequirementProfilesPayload {
  matchRequirementProfiles: MatchRequirementProfile[] | undefined;
}

interface SetVerificationTemplateSchemaPayload {
  schema: VerificationTemplateVersionSchema;
}

interface SetVerificationTemplateVersionDiffDataPayload {
  verificationTemplateVersionDiff: VerificationTemplateVersionDiff;
}

const { reducer, actions } = createSlice({
  name: 'verification-templates',
  initialState,
  reducers: {
    clearVerificationTemplate: () => {
      return initialState;
    },
    setVerificationTemplate: (state, action: PayloadAction<SetVerificationTemplatePayload>) => {
      state.verificationTemplate = action.payload.verificationTemplate;
    },
    setVerificationTemplateVersion: (
      state,
      action: PayloadAction<SetVerificationTemplateVersionPayload>,
    ) => {
      state.verificationTemplateVersion = action.payload.verificationTemplateVersion;
    },
    setLatestPublishedVerificationTemplateVersion: (
      state,
      action: PayloadAction<SetVerificationTemplateVersionPayload>,
    ) => {
      state.latestPublishedVerificationTemplateVersion = action.payload.verificationTemplateVersion;
    },
    setMatchRequirementProfiles: (
      state,
      action: PayloadAction<SetMatchRequirementProfilesPayload>,
    ) => {
      state.matchRequirementProfiles = action.payload.matchRequirementProfiles;
    },
    setVerificationTemplateSchema: (
      state,
      action: PayloadAction<SetVerificationTemplateSchemaPayload>,
    ) => {
      state.schema = action.payload.schema;
    },
    setVerificationTemplateVersionDiff: (
      state,
      action: PayloadAction<SetVerificationTemplateVersionDiffDataPayload>,
    ) => {
      state.verificationTemplateVersionDiff = action.payload.verificationTemplateVersionDiff;
    },
  },
});

export const {
  clearVerificationTemplate,
  setVerificationTemplate,
  setVerificationTemplateVersion,
  setLatestPublishedVerificationTemplateVersion,
  setMatchRequirementProfiles,
  setVerificationTemplateSchema,
  setVerificationTemplateVersionDiff,
} = actions;

export const verificationTemplateReducer = reducer;
